export var cdlEvent = "cdl_event";
export var customerHeaderModuleCollaboratorClickEvent = {
  'event_name': 'button.click',
  'event_data': {
    'button_name': 'search a customer'
  }
};